var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable prettier/prettier */
import React from 'react';
import { Modal } from 'antd';
import UserCard from '../UserCard/index';
import { getIsSelf, getUserCardDetail } from '../UserCard/common';
import server from '../server';
import Modals from '../Modals';
import { UserCardAction, UserCardType, } from '../UserCard/UserCardType';
export function openWebUserCardModal(options) {
    return __awaiter(this, void 0, void 0, function () {
        var accessToken, currentUserData, openUserId, openTeamId, env_pre, 
        // onClose,
        modalOptions, appId, source, fromUrl, rest, Authorization, error_1, data, webIsFriend, getUserCardInfo, webUserCardInfo, sendApplyFriend, actionClick, webExamineMobileRecord;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    accessToken = options.accessToken, currentUserData = options.currentUserData, openUserId = options.openUserId, openTeamId = options.openTeamId, env_pre = options.env_pre, modalOptions = options.modalOptions, appId = options.appId, source = options.source, fromUrl = options.fromUrl, rest = __rest(options, ["accessToken", "currentUserData", "openUserId", "openTeamId", "env_pre", "modalOptions", "appId", "source", "fromUrl"]);
                    console.log('openWebUserCardModal=============', options);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, server.ebook.getWebAuthInfo({
                            params: {
                                client: 'Windows',
                                lang: 'zh_CN',
                                fromUrl: fromUrl,
                            },
                            accessToken: accessToken,
                            env_pre: env_pre,
                            source: source,
                        })];
                case 2:
                    Authorization = _a.sent();
                    console.log('鉴权接口', Authorization);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [2 /*return*/];
                case 4:
                    data = { userId: openUserId, teamId: openTeamId, type: UserCardType.Web, appId: appId };
                    webIsFriend = 1;
                    getUserCardInfo = function () { return __awaiter(_this, void 0, void 0, function () {
                        var result, data;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, getUserCardDetail({ openUserId: openUserId, openTeamId: openTeamId, isMulti: true }, accessToken, env_pre, source)];
                                case 1:
                                    result = _a.sent();
                                    data = __assign(__assign({}, result), { teamId: openTeamId, userId: openUserId });
                                    webIsFriend =
                                        result.friendship === 1 || result.friendship === 8 || getIsSelf(currentUserData, data)
                                            ? 1
                                            : 0;
                                    return [2 /*return*/, data || null];
                            }
                        });
                    }); };
                    return [4 /*yield*/, getUserCardInfo()];
                case 5:
                    webUserCardInfo = _a.sent();
                    sendApplyFriend = function (accessPhone, info) { return __awaiter(_this, void 0, void 0, function () {
                        var result;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, server.ebook.applyFriend({
                                        params: {
                                            openUserId: openUserId,
                                            openTeamId: openTeamId,
                                            accessPhone: Number(accessPhone),
                                            info: info,
                                        },
                                        accessToken: accessToken,
                                        env_pre: env_pre,
                                        source: source,
                                    })];
                                case 1:
                                    result = _a.sent();
                                    return [2 /*return*/, { close: false, data: true }];
                            }
                        });
                    }); };
                    actionClick = function (props) { return __awaiter(_this, void 0, void 0, function () {
                        var type, data, accessPhone, replyMsg;
                        return __generator(this, function (_a) {
                            type = props.type, data = props.data, accessPhone = props.accessPhone, replyMsg = props.replyMsg;
                            switch (type) {
                                case UserCardAction.Send:
                                    // console.log('发送发送', data, accessPhone);
                                    return [2 /*return*/, sendApplyFriend(accessPhone, data.validationMsg)];
                                default:
                                    break;
                            }
                            return [2 /*return*/, { close: true, data: true }];
                        });
                    }); };
                    webExamineMobileRecord = function (params) { return __awaiter(_this, void 0, void 0, function () {
                        var data_1, error_2;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    return [4 /*yield*/, server.ebook.getRecordCheck({
                                            params: params,
                                            accessToken: accessToken,
                                            env_pre: env_pre,
                                            source: source,
                                        })];
                                case 1:
                                    data_1 = _a.sent();
                                    return [2 /*return*/, [data_1.check, null]];
                                case 2:
                                    error_2 = _a.sent();
                                    return [2 /*return*/, [null, error_2]];
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); };
                    // const currentUserData = {
                    //     userId: '758b81b2cda625c7fed71b564da11251',
                    //     teamId: '5363013dad8053a204b33e2784a86ff2',
                    //     appId: 'gwork',
                    //     unitName: '哈哈哈',
                    //     name: '孙小淋',
                    // };
                    // console.log(data, webUserCardInfo, currentUserData, 5555, webIsFriend);
                    Modals.UserCard(__assign(__assign({}, options), { data: data, webIsFriend: webIsFriend, currentUserData: currentUserData, webUserCardInfo: webUserCardInfo }), { onActionClick: actionClick, webExamineMobileRecord: webExamineMobileRecord });
                    return [2 /*return*/];
            }
        });
    });
}
export function UserCardModal(props) {
    var options = props.options, modalOptions = props.modalOptions, getAllRelationShip = props.getAllRelationShip, onClose = props.onClose, remarkSet = props.remarkSet, onActionClick = props.onActionClick, onGetUserInfo = props.onGetUserInfo, examineMobileRecord = props.examineMobileRecord, webExamineMobileRecord = props.webExamineMobileRecord, visible = props.visible;
    console.log('props====', props);
    var data = options.data, currentUserData = options.currentUserData, webIsFriend = options.webIsFriend, webUserCardInfo = options.webUserCardInfo, buttons = options.buttons;
    var appId = data.appId, userId = data.userId, teamId = data.teamId, type = data.type;
    var _a = React.useState(''), friendErrMsg = _a[0], setFriendErrMsg = _a[1];
    var _b = React.useState(-1), isfriend = _b[0], setIsFriend = _b[1];
    var _c = React.useState(false), visibleFriends = _c[0], setVisibleFriends = _c[1];
    var _d = React.useState({
        contactType: null,
        friendship: 1,
        isEnableAddFriend: true,
        isOnlyScanAdd: false,
        relation: 1,
        isRemove: false,
    }), contactRelationship = _d[0], setContactRelationship = _d[1];
    React.useEffect(function () {
        if (!appId || !userId || !teamId || !getAllRelationShip) {
            return;
        }
        setIsFriend(-1);
        setFriendErrMsg('');
        // app相同 teamId相同，可以直接会话
        // if (appId === currentEmployee.app && teamId === currentEmployee.teamId) {
        //     setIsFriend(true);
        //     return;
        // }
        if (getAllRelationShip)
            getIsFriends(appId, userId, teamId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var gerFriendShip = function (_a) {
        var friendship = _a.friendship;
        if (friendship === 1 || friendship === 8 || getIsSelf(currentUserData, data)) {
            setIsFriend(1);
            return;
        }
        else if (friendship === 0 || friendship === 4) {
            setIsFriend(0);
            return;
        }
    };
    function getIsFriends(appId, userId, teamId) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, AllRelationShip, err, contactType, friendship, isEnableAddFriend, isOnlyScanAdd, relation;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, getAllRelationShip({
                            oppoUserId: userId,
                            oppoTeamId: teamId,
                            appId: appId,
                        })];
                    case 1:
                        _a = _b.sent(), AllRelationShip = _a[0], err = _a[1];
                        if (err) {
                            setFriendErrMsg(err);
                            console.error(err);
                            return [2 /*return*/];
                        }
                        contactType = AllRelationShip.contactType, friendship = AllRelationShip.friendship, isEnableAddFriend = AllRelationShip.isEnableAddFriend, isOnlyScanAdd = AllRelationShip.isOnlyScanAdd, relation = AllRelationShip.relation;
                        // 是否可添加好友 isEnableAddFriend
                        // 好友关系 friendship
                        // 同事关系 relation
                        // 是否只能扫码添加 isOnlyScanAdd
                        // 联系人类型 contactType
                        setContactRelationship(__assign(__assign({}, AllRelationShip), { isRemove: (friendship === 1 || friendship === 8) && !getIsSelf(currentUserData, data)
                                ? true
                                : false }));
                        // friendShip:0无友谊（路人），1好友，2黑名单，4被关注（B的好友列表中有A，但是A的好友列表没有B），8单相思（A的好友列表有B，但是B的好友列表没有A）
                        // relation:1同事，2陌生人
                        // isEnableAddFriend  false 不需要加好友 有可见关系(可见)  true 需要加好友 没有可见关系(不可见)
                        // 好友关系如果可见 并且 是同事或者好友 不用添加好友
                        // 不需要对可见性做处理 只需要对friendShip做处理
                        if (type !== UserCardType.Web) {
                            if (isEnableAddFriend === false) {
                                // 组织可见联系人进行添加联系人的操作
                                if (friendship === 1 || friendship === 8) {
                                    setIsFriend(1);
                                    return [2 /*return*/];
                                }
                                else if (friendship === 0 || friendship === 4) {
                                    setVisibleFriends(true);
                                    setIsFriend(1);
                                    return [2 /*return*/];
                                }
                                else {
                                    setIsFriend(0);
                                    return [2 /*return*/];
                                }
                            }
                            else {
                                gerFriendShip({ friendship: friendship });
                            }
                        }
                        else {
                            gerFriendShip({ friendship: friendship });
                        }
                        return [2 /*return*/];
                }
            });
        });
    }
    // console.log(
    //     2222,
    //     type,
    //     getIsSelf(currentUserData, data),
    //     webIsFriend,
    //     data,
    //     currentUserData,
    //     visible,
    //     isfriend,
    //     friendErrMsg
    // );
    if (type !== 'web' && isfriend === -1 && !friendErrMsg) {
        return null;
    }
    return (
    // <InputAreaContext.Provider value={{}}>
    React.createElement(Modal, __assign({ visible: visible, closable: false, onCancel: onClose, footer: null, bodyStyle: {
            padding: 0,
            width: 330,
        }, wrapClassName: "me-user-card-modal", maskStyle: {
            backgroundColor: 'transparent',
        }, destroyOnClose: true }, modalOptions), type === UserCardType.Web ? (React.createElement(UserCard, { data: data, contactRelationship: __assign(__assign({}, contactRelationship), { friendship: webUserCardInfo.friendship }), remarkSet: remarkSet, isfriend: webIsFriend, onActionClick: onActionClick, webUserCardInfo: webUserCardInfo, currentEmployee: currentUserData, hideUserCardModal: onClose, webExamineMobileRecord: webExamineMobileRecord })) : (React.createElement(UserCard, { friendErrMsg: friendErrMsg, contactRelationship: contactRelationship, isfriend: isfriend, data: __assign(__assign({}, data), { type: UserCardType.CustomUser }), onActionClick: onActionClick, onGetUserInfo: onGetUserInfo, examineMobileRecord: examineMobileRecord, currentEmployee: currentUserData, remarkSet: remarkSet, hideUserCardModal: onClose, buttons: __assign(__assign({}, buttons), { add: buttons.add && visibleFriends }) })))
    // </InputAreaContext.Provider>
    );
}
//# sourceMappingURL=index.js.map